/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { DocumentFieldDisplay } from "./display";
import { DocumentFieldEdit } from "./edit";

const DocumentField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <DocumentFieldDisplay />,
        editComponent: <DocumentFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
DocumentField.displayName = "DocumentField";
export { DocumentField };
